/**
 * DEV-611: сообщество TrueSpace — в его закреплённых постах показываем кнопки
 * VPN / TrueSpace AI. Та же константа на бэке: config/app.config.ts.
 */
export const TRUESPACE_COMMUNITY_PATH = "truespace";
